import React, { ImgHTMLAttributes, useCallback } from 'react';
import { TeamID } from '../types';
import { useTranslation } from '@root/misc/useTranslation';

const teamImageContext = require.context("@images/teams", true, /.*\.svg/)
const teamImageSrc = (team: TeamID) => {
  try {
    return teamImageContext(`./logo__${team}.svg`)
  } catch(err) {
    return ""
  }
}

export const useTeamImgProps = () => {  
  const { t } = useTranslation();

  return useCallback((teamId: TeamID): ImgHTMLAttributes<HTMLImageElement> => {
    const label = t(`teams.${teamId}`);
    return {
      src: teamImageSrc(teamId),
      alt: label,
      "aria-label": label,
    };
  }, [t]);
};
